import { normalizeAccountNumber } from "@common/helpers/accountNumberMatch";
import { AccountInfoExtraction } from "@common/schemas/financialDocument/account-info-extraction.schema";

type StatementAccountInfo = Pick<
    AccountInfoExtraction,
    "accountNumber" | "institutionName" | "accountName"
>;

function normalizeKeyPart(value: string | null | undefined): string {
    return (value ?? "").replace(/\s+/g, "").toLowerCase();
}

export function getStatementAccountKey(
    accountInfo: StatementAccountInfo | null | undefined,
): string | null {
    const accountNumber = normalizeAccountNumber(accountInfo?.accountNumber);
    if (accountNumber) {
        return `number:${accountNumber}`;
    }

    const institutionName = normalizeKeyPart(accountInfo?.institutionName);
    const accountName = normalizeKeyPart(accountInfo?.accountName);
    if (institutionName && accountName) {
        return `institution:${institutionName}|name:${accountName}`;
    }

    return null;
}
